export const sectionNames = {
  advertisingNew: 'Advertising',
  botBuilder: 'Chatbots',
  websiteChat: 'Website Chat',
  sms: 'SMS',
  instagramWelcomer: 'Instagram DM Responder',
  instagramStoryMention: 'Instagram Story Mentions',
  instagramStoryReactions: 'Instagram Story Reactions',
  instagramCommentGuard: 'Instagram Comment Guard',
  instagramLive: 'Instagram Live',
};
